<script>
	import { getContext, onMount } from 'svelte';
    import { win, loaded, lang, phone, overPhone, showingLegal, scrollY, totalLayers } from "./store.js";
    // -
    let _win = false;
    win.subscribe( value => { _win = value; } );
    // -
    $: folder = _win.width <= _win.wMaxSm ? '1080' : '1920';
    // -
    const scaleScroll = 1;
    $: scrollYis0 = $scrollY <= 0;

	// - Snow
	import {particlesJson} from './particlesJson.js';
    // -
	let particlesReady = false;
	let mounted = false;
	// -

	function initSnow(){
        const numParticles = _win.width <= _win.wMaxSm ? 200 : _win.width <= _win.wMaxMd ? 450 : 700;
        particlesJson.particles.number.value = numParticles;
        particlesJson.particles.size.value = _win.width <= 480 ? 1.2 : _win.width <= 768 ? 1.4 : 1.0;
        // -
		particlesJS('snow', particlesJson);
	}
	function particlesLoaded() {
        setTimeout( function(){
            particlesReady = true;
            if (mounted) {
                initSnow();
            }
		}, 1000 );
    }
	onMount(function(){
        setTimeout( function(){
            mounted = true;
		    // -
			if (particlesReady) {
                initSnow();
            }
		}, 1000 );
	});
</script>




<svelte:head>
	<script src="particles.min.js" on:load={particlesLoaded}></script>
</svelte:head>

<template lang="pug">
    header( class:loaded="{$loaded}" scroll="{$scrollY}")

        +if('_win.width >= _win.wMaxSm')
            video.capa#sky( playsinline preload="auto" autoplay loop muted poster='./img/header_{folder}/sky.png' style="transform: translateY({-scrollY * (1 / totalLayers) * scaleScroll}px)")
                source(src="./vid/header_1920/sky.mp4")

            +else()
                img.capa#sky( src="./img/header_{folder}/sky.png" alt="sky" style="transform: translateY({-$scrollY * (1 / totalLayers) * scaleScroll}px)")

        img.capa#background( src="./img/header_{folder}/mountains.png" alt="background" style="transform: translateY({-$scrollY * (2 / totalLayers) * scaleScroll}px)")
        .capa#vignette(style="transform: translateY({-$scrollY * (3 / totalLayers) * scaleScroll}px);" )
        .capa#rescue(style="transform: translateY({(-$scrollY * (4 / totalLayers) * scaleScroll) + ($loaded ? 0 : 280)}px)" class:easing="{scrollYis0}")
            .text
                +if( '$lang === "cat"' ) RESCAT
                    +elseif( '$lang === "esp"' ) RESCATE
                        +else() RESCUE

        img.capa#flota( src="./img/header_{folder}/flota.png" alt="cars" style="transform: translateY({-$scrollY * (5 / totalLayers) * scaleScroll}px)" )
        .capa#snow( style="transform: translateY({-$scrollY * (6 / totalLayers) * scaleScroll}px)" )
		
</template>




<style global lang="stylus">
	@require "./stylus/globals"
	// -
    header
        position relative
        display inline-block
        width 100vw
        overflow hidden
        height auto

        @media $Md
            width calc(100vw + 30vw)
            margin-left -15vw

        @media $Sm
            width calc(100vw + 100vw)
            margin-left -50vw

        .capa
            position absolute
            display block
            top 0
            left 0
            width 100%
            will-change transform

            &#sky
                $prop = 1920 / 282
                z-index -10

            &#background
                position relative
                z-index -9

            &#vignette
                background linear-gradient(180deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.0) 30%)
                height 100%
                z-index -8

            &#rescue
                color $orange
                text-transform uppercase
                z-index -7
                color $orange

                display flex
                flex-flow row
                justify-content center

                will-change transform

                &.easing
                    transition transform 2s cubic-bezier(0.65, 0.01, 0.01, 0.99)

                .text
                    fBig()
                    font-size 20vw

                top 13%
                @media $Md
                    top 18%
                    .text
                        font-size 23vw

                @media $Sm
                    top 24%
                    .text
                        font-size 26vw
                
            &#flota
                z-index -6

            &#snow
                height 100%
                z-index -5

</style>